import { GET_USER, CLEAR_USER } from '../constants';
import { fetchUserService } from '../../services/api';

export const fetchUser = username => ({
  type: GET_USER,
  async payload() {
    const data = await fetchUserService(username);
    return data;
  },
});

export const clearCurrentUser = () => ({
  type: CLEAR_USER,
});



// WEBPACK FOOTER //
// ./src/redux/actions/user.js